import React, { useState } from 'react';

import Dialog from 'components/Dialog';
import AddCard from './AddCard';


export const useAddCardDialog = () => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };


  const renderDialog = ({
    getCard, 
    addCard,
    loadingCard,
    is_admin
  }) => (
    <Dialog
      open={open}
      hideActions
      loading={false}
      showFloatingCancel
      onClose={handleClose}
      title="Add Card"
    >
      
       <AddCard
          addAccountCard={addCard}
          getCard={getCard}
          userIsAdmin={is_admin}
          loadingCard={loadingCard}
        />
     
    </Dialog>
  );

  return [renderDialog, handleOpen, handleClose];
};

export default useAddCardDialog;
